export enum ControlMessage {
  role_enum = 'Role',
  name = 'Nama',
  phone_number = 'Nomor Telepon',
  email = 'Email',
  area_id = 'Area',
  area_ids = 'Area',
  sub_area_id = 'Sub Area',
  regency_id = 'Kota',
  district_id = 'Kecamatan',
  sub_district_id = 'Kelurahan',
  full_address = 'Alamat lengkap',
  reject_reason = 'Alasan penolakan',
  batch_name = 'Nama batch',
  npwp = 'NPWP',
  id_periode = 'Periode',
  maximal_discount = 'Diskon'
}
